import { BAND_PART_1 } from './letterheadBand1'
import { BAND_PART_2 } from './letterheadBand2'
import { BAND_PART_3 } from './letterheadBand3'
import { BAND_PART_4 } from './letterheadBand4'

/**
 * The charcoal header bar from the Portal Productions letterhead, full bleed,
 * carrying the official lockup and `Dubai, UAE` exactly as supplied by Tom
 * (`Portal Productions Blank Letterhead.docx`, 11 Sep 2026). The wordmark here
 * is the one from the letterhead itself - it is never retyped or redrawn, in
 * line with the standing rule in data/projects.ts.
 *
 * This is the only part of the letterhead that genuinely has to be carried as
 * artwork: the arc motif turned out to be eight circles and is now drawn (see
 * letterheadArcs.ts), and the footer line is one short strip. Greyscale JPEG
 * at the artwork's native resolution, 1448 x 146 px, printed at
 * 595.28 x 60.02 pt - about 175 dpi. JPEG rather than PNG because the bar is a
 * smooth left-to-right gradient, which PNG stores very badly.
 *
 * WHY THIS IS IN FOUR PIECES, which is otherwise an odd thing to do: the data
 * URI is ~12,400 characters and has to be transcribed by hand into this repo.
 * Transcribing it in one go failed twice - once losing 222 characters outright,
 * once splicing in a fragment of a previous revision of the same image, both
 * of which produce a corrupt bar rather than a clean failure. Split into four
 * ~3,100-character parts, each part can be written and diffed against the
 * source independently, and a bad part can be rewritten without touching the
 * three good ones. Join order is 1, 2, 3, 4 and must not change.
 *
 * If the letterhead is ever redesigned, re-cut the bar, split the new base64
 * into four parts and replace all four files together.
 *
 * See assets/letterhead.ts for placement.
 */
export const LETTERHEAD_BAND =
  `data:image/jpeg;base64,${BAND_PART_1}${BAND_PART_2}${BAND_PART_3}${BAND_PART_4}`
